import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatsWidgetNumber from '@rio-cloud/rio-uikit/StatsWidgetNumber';
import StatsWidgetSpacer from '@rio-cloud/rio-uikit/StatsWidgetSpacer';
import { valueStringFormat } from '../../shared/utils/formatters';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import style from './behaviorCards.module.css'
import { RouteMap } from '../../routes/routeList';
import { ScoreApiResponse } from '../../shared/models/ScoreApiResponse';
import { useNavigate } from 'react-router';



type BehaviorCardsProps = {
    data: ScoreApiResponse | null;
    scoreData: ScoreApiResponse | null;
    loading: boolean;
};


const BehaviorCards = (props: BehaviorCardsProps) => {

    const { data, loading, scoreData } = props;

    const behaviorRoute = `/${RouteMap.get('behavior')}`;
    const relationshipRoute = `/${RouteMap.get('relationship')}`;
    const safeDrivingRoute = `${behaviorRoute}/${RouteMap.get('safeDriving')}`;
    const predictiveRoute = `${behaviorRoute}/${RouteMap.get('predictive')}`;
    const esgRoute = `${behaviorRoute}/${RouteMap.get('esg')}`;

    const navigate = useNavigate();

    return (
        <StatsWidget>
            <div className={location.pathname.includes(behaviorRoute) ? style['border-selction'] : style['border-inative']} >
                <StatsWidget.Header className={''}>Comportamento</StatsWidget.Header>
                <StatsWidget.Body>
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const scoreDataValue = data?.safe ? valueStringFormat(data?.safe) : valueStringFormat(scoreData?.safe ? scoreData.safe : 0);
                            const isClickable = location.pathname !== safeDrivingRoute && location.pathname !== behaviorRoute && !location.pathname.includes(relationshipRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(safeDrivingRoute);
                                    }
                                }} className={''} value={scoreDataValue} label='Direção Segura' />
                            )
                        }
                    })()}
                    <StatsWidgetSpacer />
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const scoreDataValue = data?.predictive ? valueStringFormat(data?.predictive) : valueStringFormat(scoreData?.predictive ? scoreData.predictive : 0);
                            const isClickable = location.pathname !== predictiveRoute && location.pathname !== behaviorRoute && !location.pathname.includes(relationshipRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(predictiveRoute);
                                    }
                                }} value={scoreDataValue} label='Preditivo' />
                            )
                        }
                    })()}
                    <StatsWidgetSpacer />
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const scoreDataValue = data?.esg ? valueStringFormat(data?.esg) : valueStringFormat(scoreData?.esg ? scoreData.esg : 0);
                            const isClickable = location.pathname !== esgRoute && location.pathname !== behaviorRoute && !location.pathname.includes(relationshipRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(esgRoute);
                                    }
                                }} className={''} value={scoreDataValue} label='Sustentável' />
                            )
                        }
                    })()}
                    <StatsWidgetSpacer />
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            let security = 0;
                            return (
                                <StatsWidgetNumber className='StatsWidgetNumber-label-disabled StatsWidgetNumber-value-disabled' value={valueStringFormat(security)} label='Risco' />
                            )
                        }
                    })()}
                </StatsWidget.Body>
            </div>
        </StatsWidget>
    )
}

export default BehaviorCards;

